import React, { Component } from 'react'
import './css.css';
import Web3 from 'web3';
import utils from './../../library'
class Referral extends Component {
   
componentDidMount(){
    this.loadRefs()
}

async loadRefs(){
    await window.ethereum.enable().then(async function (accounts) {
        
        const refs = new web3.eth.Contract(REFERRALABI, REFERRAL) 
        let amount=await refs.methods.amount().call()
        document.getElementById("Referral_tot_ref").textContent=amount
        
    })
}
    async create(){
        document.getElementById("Referral_input_button_create_badge").value="🛒 minting..."
        await window.ethereum.enable().then(async function (accounts) {
            const refs = new web3.eth.Contract(REFERRALABI, REFERRAL) 
            let tot=document.getElementById("Referral_input_text_field_amount").value
            if(tot>3){
            tot=3
            document.getElementById("Referral_tot_ref").textContent=3
            alert("max minting = 3 at once (block gas limit)")
            }
            await refs.methods.mint(await utils.extractReferral()).send({value: tot*10000000000000000, gasLimit:5000000, from:accounts[0]})
            let amount=await refs.methods.amount().call()
            document.getElementById("Referral_tot_ref").textContent=amount
        })
        
        document.getElementById("Referral_input_button_create_badge").value="🛒 MINT REF BADGE"
    }

    render(){
        console.log(this.props.update) 
        return ( 
            <div>
                <div id="bows_flyer" className="text white">
                    <div id="bows_mainlabel">💰 REFERRAL ECONOMY</div>
                    <div id="bows_sublabel">Referral Ecosystem Features</div>
                    <div className="bows_panel dark darkblue text white">
                        <div className="instructions_title light lightblue text white">📦 Refer a Shop</div>
                        <br></br><br></br>
                        Refer a Shop and in case anything is sold you get 20% of the fees connected to the sale/operation.
                        <br></br>
                        <br></br>
                        <br></br>
                        <div className="instructions_title light lightblue text white">👻 GhostShop</div>
                        <br></br><br></br>
                        Create a GhostShop by aggregating third parties products and earn 20% of the fees from resulting sales.
                        <br></br>
                        <br></br>
                        <br></br>
                        <div className="instructions_title light lightblue text white">🎪 Districts</div>
                        <br></br><br></br>
                        Create a Shopping District and ask a tip to shops willing to join it. (Under Construction)
                        <br></br>
                        <br></br>
                        Earn 20% of fees from all products sold in any shop to visitors of your district
                        <br></br>
                        <br></br>
                        <br></br>
                        <div className="instructions_title light lightblue text white">🍀 Referral Lottery</div>
                        <br></br><br></br>
                        <div className="Referral_label left text white">Registered Referrals:</div>
                        <div id="Referral_tot_ref" className="Referral_label right text white"> </div>
                        <div className="clear"/>
                        <div className="Referral_sublabel left text white">Mint Referral Badge: </div>
                <input type="text" id="Referral_input_text_field_amount" className="Referral_input_text_field_amount light lightblue text white" defaultValue="1"></input>
                <div className="clear"/>
                <input type="button" id="Referral_input_button_create_badge" className="Referral_input_button light lightblue text white"  onClick={() => this.create()} value="🛒 MINT REF BADGE"></input>
                <input type="button" id="Referral_input_button_look_badge" className="Referral_input_button light lightblue text white right"  onClick={() => window.open("https://ethitem.com/?collection=0x8dE0c64cba69FE2e706029Bc57C2aB9b3204861c")} value="👁️"></input>
                <div className="clear"/>
                <br></br><br></br>
                        Unreferred products produce a fee prize to a random Official Referral.
                        <br></br><br></br>
                        SmartShop is a platform downloaded from ipfs and runs locally: the buyer of a product is running it and locally produces the extraction of the referral winner.
                    </div>
                </div>
            </div>
        );
    }

}


const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")
let REFERRALABI=[ { "inputs": [], "name": "HappyFarm", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "_collection", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "amount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "badgeToSmartWallet", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "init", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "list", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "lister", "outputs": [ { "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_ref", "type": "address" } ], "name": "mint", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [], "name": "pull", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "uri", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "stateMutability": "view", "type": "function" } ]
let REFERRAL="0x1008CCfe12Bc43a5Cd5D53710284A532306F29B8";
export default Referral